module.exports = __webpack_public_path__ + "static/media/lorrygif3.5fc1f217.gif";